import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import firebaseApp from "../firebase/credenciales";

const db = getFirestore(firebaseApp);

/**
 * Servicio para registrar auditoría por eventos de negocio (Opción B)
 * @param {string} tipoAccion - Ej: "CREAR_USUARIO", "ELIMINACION_MASIVA"
 * @param {string} modulo - Ej: "GestionUsuarios"
 * @param {object} detalles - Objeto con datos relevantes a la acción
 * @param {object} usuarioAdmin - El objeto del administrador logueado que hizo la acción
 */
export const logBusinessAction = async (tipoAccion, modulo, detalles, usuarioAdmin) => {
  try {
    if (!usuarioAdmin) {
      console.warn("AuditService: No se recibió usuarioAdmin para registrar la auditoría.");
      return;
    }

    await addDoc(collection(db, "audit_logs"), {
      accion: tipoAccion,
      modulo: modulo,
      adminDni: usuarioAdmin.dni || "desconocido",
      adminEmail: usuarioAdmin.email || "desconocido",
      adminNombre: usuarioAdmin.name || usuarioAdmin.nombre || "desconocido",
      adminRol: usuarioAdmin.rol || "desconocido",
      rucEmpresa: usuarioAdmin.ruc || "desconocido",
      timestamp: serverTimestamp(),
      detalles: detalles
    });
    console.log(`[Auditoría] Acción registrada: ${tipoAccion}`);
  } catch (error) {
    console.error("Error guardando log de auditoría:", error);
  }
};
